module.exports = __webpack_public_path__ + "static/media/delete_dark.cc1579c5.svg";